import api from './api';

export type NotificationCategory = 'task' | 'project' | 'case' | 'chat' | 'event' | 'birthday';

export interface NotificationApiItem {
  id: number;
  category: NotificationCategory;
  body: string;
  meta: Record<string, unknown>;
  is_read: boolean;
  read_at: string | null;
  created_at: string | null;
  actor: { id: number; name: string; avatar: string | null } | null;
}

export interface NotificationStats {
  total: number;
  unread: number;
  task: number;
  project: number;
  case: number;
  chat: number;
  event: number;
  birthday: number;
}

export interface NotificationsListResponse {
  data: NotificationApiItem[];
  total: number;
  unread_total: number;
  stats: NotificationStats;
  per_page: number;
  current_page: number;
  last_page: number;
}

export interface FetchNotificationsParams {
  page?: number;
  perPage?: number;
  category?: NotificationCategory;
  unreadOnly?: boolean;
}

export async function fetchNotifications(
  params: FetchNotificationsParams = {},
): Promise<NotificationsListResponse> {
  const search = new URLSearchParams();
  if (params.page) search.set('page', String(params.page));
  if (params.perPage) search.set('per_page', String(params.perPage));
  if (params.category) search.set('category', params.category);
  if (params.unreadOnly) search.set('unread_only', '1');
  const q = search.toString();
  const { data } = await api.get<NotificationsListResponse>(q ? `/notifications?${q}` : '/notifications');
  return data;
}

export async function markNotificationRead(id: number): Promise<void> {
  await api.post(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.post('/notifications/read-all');
}
